import { Injectable } from '@angular/core' ;
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router' ;
import { catchError, concatMap, Observable, of, switchMap } from 'rxjs' ;
import { ReportsService } from '../../../../core/services/reports.service' ;
import { LoadingService } from '../../../../core/services/loading.service';

@Injectable({
  providedIn: 'root'
})
export class StudentSummaryResolver  {
  constructor(
    private reportsService: ReportsService,
    private loadingService: LoadingService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    // On Student Summary load, we might be a district user or fil user, so if our selected
    // school is 'All' (ID of 0), then we cannot load students because we do not have
    // any teachers loaded
    this.loadingService.start() ;
    if (this.reportsService.getSelectedSchoolForReports().schoolID === 0)
    {
      this.loadingService.finish() ;
      return of({
        erred: true,
        message: 'Please select a School',
      }) ;
    }

    if (this.reportsService.getSelectedTeacherForReports().userID === 0)
    {
      this.loadingService.finish() ;
      return of({
        erred: true,
        message: 'Please select a Teacher',
      }) ;
    }

    return this.reportsService.getStudentsForTeacher(this.reportsService.getSelectedTeacherForReports().userID).pipe(
      concatMap((students) => {
        this.loadingService.finish() ;
        return of({
          students: students,
        }) ;
      }),
      catchError((err, caught) => {
        this.loadingService.finish() ;
        return of({
          erred: true,
          message: err.message,
        }) ;
      })
    ) ;
  }
}
